import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import {CommandContext, ScreenFormatContext} from "@mnjsplatform/data";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import {formatMnDate} from "@mnjsplatform/data/lib/utils/formatData";

class AboutInfo extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isDataReady: false
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            this.setState({isDataReady: false});
            await this.props.dispatch(this.props.dataItem_Info_1.execute({}, {withParams: true}));
            await this.props.dispatch(this.props.dataItem_Info_2.execute());
            await this.props.dispatch(this.props.dataItem_Info_3.execute());
            this.setState({isDataReady: true});
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        if (!this.state.isDataReady)
            return null;
        return (<ScreenFormatContext.Consumer>
            {
                isDesktop => {
                    return <PlaceholderWrapper placeholderId="10" title={i18next.t('Сведения обо мне')}>
                        <PlaceholderWrapper placeholderId="20" title={i18next.t('Добро пожаловать!')}>
                            <ComplexParam dataItem={this.props.dataItem_Info_1} readOnly={true} showSearchBar={false}
                                          showApplyButton={false} renderParams={paramRender}/>
                        </PlaceholderWrapper>
                        <PlaceholderWrapper placeholderId="30" title={i18next.t('Согласие на обработку персональных данных')}>
                            <div className="d-flex align-items-baseline">
                                <ComplexParam dataItem={this.props.dataItem_Info_1_Params} parentDataItem={this.props.dataItem_Info_1}
                                              autoApplyParams={true}
                                              showSearchBar={false} showApplyButton={false}/>
                                <div className="ml-2 font-weight-bold text-danger">
                                    {i18next.t('AgreeDate', {date: formatMnDate(this.props.dataItem_Info_1.getField(0, 'PersDataAgreeDate'))})}
                                </div>
                            </div>
                        </PlaceholderWrapper>
                        <PlaceholderWrapper placeholderId="40" title={i18next.t('Руководитель')}>
                            <ComplexParam dataItem={this.props.dataItem_Info_2} readOnly={true} showSearchBar={false}
                                          autoApplyParams={true} showApplyButton={false} renderParams={paramRender}/>
                        </PlaceholderWrapper>
                        <PlaceholderWrapper placeholderId="50" title={i18next.t('Рекрутер')}>
                            <ComplexParam dataItem={this.props.dataItem_Info_3} readOnly={true} showSearchBar={false}
                                          showApplyButton={false} renderParams={paramRender}/>
                        </PlaceholderWrapper>
                    </PlaceholderWrapper>
                }
            }
        </ScreenFormatContext.Consumer>);
    }
}

AboutInfo.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_Info_1: PropTypes.object,
    dataItem_Info_1_Params: PropTypes.object,
    dataItem_Info_2: PropTypes.object,
    dataItem_Info_3: PropTypes.object,
}

AboutInfo.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_Info_1: state.selfServiceState.SelfServiceFrame_PrelimInfo1,
        dataItem_Info_1_Params: state.selfServiceState.SelfServiceFrame_PrelimInfo1_Params,
        dataItem_Info_2: state.selfServiceState.SelfServiceFrame_PrelimInfo2,
        dataItem_Info_3: state.selfServiceState.SelfServiceFrame_PrelimInfo3,
    }
}

export default connect(mapStateToProps)(AboutInfo)